<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Gallery </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section col-12">
            <div class="container">
                <div class="row">
                    <div class="gallety-main-section col-12 float-l">
                        <div class="row">
                            <ul class="portfolio-categ filter">
                                <li class="photovideo cat-item-1 active"><a v-on:click.prevent="photoVideoToggle($event);" id='photo' title="Photos">Photos</a>
                                </li>
                                <li class="photovideo cat-item-2"><a v-on:click.prevent="photoVideoToggle($event);" id='video' title="Videos">Videos</a>
                                </li>
                            </ul>
                            <div class="cat-section-mobile float-l width-full">
                                <h6 class="float-l"> Select Categories</h6>
                                <div class="clearfix"></div>
                                <div class="cat-section-mobile float-l width-full">
                                    <v-select style="" class=""
                                              v-model="mainCategoryId"
                                              name="mainCategoryId"
                                              id="mainCategoryId"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="mainCategoryArr"
                                              placeholder="Select Category">
                                    </v-select>
                                </div>

                                <ul class="float-l width-full">
                                    <li :class="'category category_'+responsiveAllTab+' active'" v-on:click="getImages(responsiveAllTab);"> {{responsiveCategoryName}} </li>
                                    <template v-for="(categoryData , index) in subCategoryArr">
                                        <li :class="'category category_' + categoryData.value" v-on:click="getImages(categoryData.value,'sub');"> {{categoryData.text}} </li>
                                    </template>
                                </ul>
                            </div>
                            <div class="bottom-gallery-detail-main col-12 float-l">
                                <div class="row">
                                    <p class="gallery-title float-l width-full"> {{categoryName}} </p>
                                    <template v-if="categoryDescription != ''">
                                        <p class="gallery-title-description"> {{categoryDescription}} </p>
                                        <div class="clearfix"></div>
                                    </template>
                                    <div class="portfolio-content col-12 col-sm-9 col-md-9 col-lg-9">
                                        <!--left side-->
                                        <div class="row">
                                            <ul class="portfolio-area">
                                                <template v-for="(text, index) in imageList">
                                                    <li class="portfolio-common portfolio-photo portfolio-item2 col-12 col-sm-4 col-md-4 col-lg-4" data-id="id-1" data-type="cat-item-1">
                                                        <div>
                                                            <span class="image-block">
                                                                <div class="hover-home-eefect employee-border">
                                                                    <a class="image-zoom" :href="text.image" rel="prettyPhoto[gallery]" :title="text.caption">
                                                                        <img :src="text.image"/>
                                                                    </a>
                                                                </div>
                                                                <p>{{captionTrim(text.caption)}}</p>
                                                            </span>
                                                        </div>
                                                    </li>    
                                                    <template v-if="((Number(index) + 1)%3) == 0">
                                                        <div class="clearfix"></div>
                                                    </template>
                                                </template>
                                                <template v-for="(text, index) in videoList">
                                                    <li style="display: none;" class="portfolio-common portfolio-video portfolio-item2 col-12 col-sm-4 col-md-4 col-lg-4" data-id="id-1" data-type="cat-item-2">
                                                        <div>
                                                            <span class="image-block">
                                                                <div class="hover-home-eefect employee-border">
                                                                    <div class="video-popup">
                                                                        <!--<a href="javascript:void(0)" data-toggle="modal" v-on:click="loadVideo(text.video)" :id="'video_'+text.id"> <img :src="text.image" :alt="text.type"> </a>-->
                                                                        <a :href="'#myModal_'+text.id" data-toggle="modal"> 
                                                                            <template v-if="text.type == 'video'">
                                                                                <img :src="text.image" :alt="text.type"> 
                                                                            </template>
                                                                            <template v-if="text.type == 'url'">
                                                                                <img :src="'/static/images/video.jpg'" :alt="text.type">
                                                                            </template>
                                                                        </a>
                                                                    </div>
                                                                    <!-- Video Modal -->
                                                                    <div :id="'myModal_'+text.id" class="modal fade">
                                                                        <div class="modal-dialog">
                                                                            <div class="modal-content">
                                                                                <div class="modal-header">
                                                                                    <template v-if='text.caption != ""'>
                                                                                        <h4 class="modal-title">{{text.caption}}</h4>
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <h4 class="modal-title">{{text.category_name}}</h4>    
                                                                                    </template>
                                                                                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>                                                                                    
                                                                                </div>
                                                                                <div class="modal-body">
                                                                                    <!--<v-playback :name="'v_play'+text.id" :url="text.video" ></v-playback>-->
                                                                                    <template v-if="text.type == 'video'">
                                                                                        <video controls>
                                                                                            <source :src="text.video" type="video/mp4">
                                                                                            Your browser does not support the video tag.
                                                                                        </video>
                                                                                    </template>
                                                                                    <template v-if="text.type == 'url'">
                                                                                        <iframe v-if="text.video_url != ''" :src="text.video_url" controls width="100%" height="250"></iframe>
                                                                                    </template>
                                                                                    <!--<iframe id="hrbenifit" width="560" height="315" :src="text.video" frameborder="0" allowfullscreen></iframe>-->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!-- Video Modal -->
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </li>    
                                                </template>
                                                <div class="column-clear"></div>
                                            </ul>
                                            <!--end portfolio-area -->
                                        </div>
                                    </div>
                                    <!--end portfolio-content -->
                                    <div class="gallery-right-cat float-l col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="gallery-cat-desktop width-full float-l">
                                            <h2 class="float-l width-full heading-text-20 line-height-24 color-red font-text-bold-mont border-bottom-dddddd pb-10"> Select Categories </h2>
                                            <ul>
                                                <li> <a v-on:click.prevent="getImages(0);" class="category category_0 active"> All </a> </li>
                                                <template v-if="categoryData.parent_id == ''" v-for="(categoryData , index) in categoryArr">
                                                    <li> <a v-on:click.prevent="getImages(categoryData.value);" href="#" :class="'category category_'+categoryData.value"> {{categoryData.text}} <span v-if="categoryData.cnt > 0" class="right-arrow-cat"> <i :class="'fa fa-caret-down main_category main_category_' + categoryData.value"></i> </span> </a>
                                                        <ul class="subcategory-gallery float-l width-full">
                                                            <template v-if="subCategoryData.parent_id == categoryData.value" v-for="(subCategoryData , index) in subCategoryArr">
                                                                <li> <a v-on:click.prevent="getImages(subCategoryData.value,'sub');" href="#" :class="'category category_'+subCategoryData.value"> {{subCategoryData.text}} </a> </li>
                                                            </template>
                                                        </ul>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import CanvasVideo from 'vue-canvasvideo';
    import 'vue-canvasvideo/dist/vuecanvasvideo.min.css';
    import vPlayBack from 'v-playback';
    Vue.use(vPlayBack);
    var self;
    export default {
        name: 'gallery',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
        },
        data() {
            return {
                responsiveAllTab: 0,
                responsiveCategoryName: 'All',
                responsiveCategoryDescription: 'All',
                mainCategoryId: {text: 'All', value: '0'},
                mainCategoryArr: [],
                video: '',
                categoryName: 'All',
                categoryDescription: '',
                photoVideoType: 'photo',
                categoryArr: [],
                imageList: [],
                videoList: [],
                subCategoryArr: [],
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.loadCategory();
            self.getBuildVersion();

            /* Get iframe src attribute value i.e. YouTube video url
             and store it in a variable */
            var url = $("#hrbenifit").attr('src');

            /* Assign empty url value to the iframe src attribute when
             modal hide, which stop the video playing */
            $("#myModal").on('hide.bs.modal', function () {
                $("#hrbenifit").attr('src', '');
            });

            /* Assign the initially stored url back to the iframe src
             attribute when modal is displayed again */
            $("#myModal").on('show.bs.modal', function () {
                $("#hrbenifit").attr('src', url);
            });
        },
        watch: {
            mainCategoryId: function (mainCategoryId) {
                /* console.log(mainCategoryId.value); */
                self.getImages(mainCategoryId.value);
                self.responsiveAllTab = (mainCategoryId === null || mainCategoryId == '') ? 0 : mainCategoryId.value;
                self.responsiveCategoryName = (mainCategoryId === null || mainCategoryId == '') ? 0 : mainCategoryId.text;
                self.responsiveCategoryDescription = (mainCategoryId === null || mainCategoryId == '') ? 0 : mainCategoryId.description;
            }
        },
        methods: {
            loadCategory() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': 'gallery',
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            var addAll = {text: 'All', value: '0'};
                            self.mainCategoryArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].parent_id == '') {
                                    self.mainCategoryArr.push(response.data.content[i]);
                                }
                            });
                            self.getImages(0);
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            getImages(id, sub) {
                sub = (typeof sub !== 'undefined') ? sub : '';
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                $('.category').removeClass('active');
                $('.category_' + id).addClass('active');
                var fields = {
                    catagory_id: id,
                };
                HTTP.post("getmedia", fields, config)
                        .then(function (response) {
                            self.imageList = [];
                            self.videoList = [];
                            setTimeout(function () {
                                self.imageList = response.data.content;
                                self.videoList = response.data.videos;
                                /*self.pprefresh();*/
                            }, 100);
                            setTimeout(function () {
                                jQuery("a[rel^='prettyPhoto']").prettyPhoto();
                            }, 500);
                            self.categoryName = response.data.category;
                            self.categoryDescription = response.data.catag_description;
                            if (sub == '') {
                                if (id) {
                                    $('.main_category').removeClass('fa-caret-up');
                                    $('.main_category').addClass('fa-caret-down');
                                    $('.main_category_' + id).removeClass('fa-caret-down');
                                    $('.main_category_' + id).addClass('fa-caret-up');
                                } else {
                                    $('.main_category').removeClass('fa-caret-up');
                                    $('.main_category').addClass('fa-caret-down');
                                }
                                self.subCategoryArr = response.data.sub_categories;
                            }
                            /*console.log(self.subCategoryArr);*/
                            if (id == 0) {
                                self.categoryName = "All";
                                self.categoryDescription = "";
                            }
                            setTimeout(function () {
                                jQuery("a[rel^='prettyPhoto']").prettyPhoto();
                                $(".portfolio-video").hide();
                                $(".portfolio-photo").show();
                                $('.photovideo').removeClass('active');
                                $('.cat-item-1').addClass('active');
                            }, 10);
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            photoVideoToggle(event) {
                $('.photovideo').removeClass('active');
                self.photoVideoType = event.target.id;
                $("#" + self.photoVideoType).parent().addClass('active');
                $(".portfolio-common").fadeOut();
                $(".portfolio-" + self.photoVideoType).fadeIn();
            },
            loadVideo(video) {
                self.video = video;
                /*console.log(self.video);*/
            },
            captionTrim(caption) {
                var caption1 = (caption.length > 30) ? caption.substring(0, 30) + '...' : caption;
                return caption1;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Gallery.vue